import { desktopFirstQuery } from '@inflearn/ds-react';
import { useMediaQuery as useMediaQueryHook } from '@mantine/hooks';

export default function useMediaQuery() {
  const isMobile = useMediaQueryHook(desktopFirstQuery.mobile);

  return {
    isMobile,
  };
}
